export default __webpack_public_path__ + "static/media/trash.7c415e3b.svg";